<template>
  <div>
		<loading :active.sync="this.$root.isLoading" loader="dots" background-color="#000" color="#fff" :opacity=1></loading>
		<router-view></router-view>
  </div>
</template>

<script>
    import config from '@/config/main.js';

    export default {
        name: 'app',
        data() {
            return {
                storeName: config.storeName,
                description: config.description
            }
        },
        mounted() {
            document.title = this.storeName;
        }
    }
</script>
